import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Service } from "../../Service/ApiService";
import { CommonService } from "../../Service/CommonService";
import Spinner from "../Common/Spinner";

interface ChildProps {
  deleteOwner: any;
  reloadTable: any;
}

const DeleteOwner: React.FC<ChildProps> = ({ deleteOwner, reloadTable }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (!deleteOwner.length) return; // No owners to delete

    setIsLoading(true);

    try {
      await Service.deleteOwner(deleteOwner);
      CommonService.Toast.fire({
        title: "Owner deleted successfully!",
        icon: "success",
      });

      reloadTable();
    } catch (error) {
      console.error(error);
      CommonService.Toast.fire({
        title: error.response.data.errorMessage,
        icon: "error",
      });
    } finally {
      setIsLoading(false);
      handleClose();
    }
  };

  return (
    <>
      <button className="primary-btn d-inline-flex me-1" onClick={handleShow}>
        <DeleteOutlinedIcon sx={{ me: 2 }} /> Delete
        <span className="review--number text-secondary d-inline-flex align-items-center justify-content-center rounded-circle bg-white ms-2">
          {deleteOwner.length}
        </span>
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        className="modal__wd modal__wd--submitSellReq"
      >
        <Modal.Header className="flex-column align-items-start">
          <Modal.Title>Delete Owner</Modal.Title>
          <p className="modal-text">
            Are you sure you want to delete the selected owner ?
          </p>
        </Modal.Header>
        <Modal.Footer className="justify-content-center bg-transparent">
          <div className="btn-group row d-flex justify-content-between w-100">
            <div className="col-6 ps-0">
              <Button
                className="secondary-btn w-100"
                onClick={handleClose}
                disabled={isLoading}
              >
                No
              </Button>
            </div>
            <div className="col-6 pe-0">
              <Button
                className="primary-btn w-100"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading && <Spinner />} Yes
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteOwner;
